<template>
  <div class="refund-details layout">
    <div class="refund-left flex">
      <div class="form-block refund-gap">
        <div class="form-title">
          <div class="form-icon"></div>
          <div class="flex">退款信息</div>
        </div>
        <div class="form-content">
          <div class="form-cell">
            <div class="form-label">用户名称：</div>
            <div class="form-value ">{{refundUserInfo.realName}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">联系电话：</div>
            <div class="form-value ">{{refundUserInfo.phone}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">退款时间：</div>
            <div class="form-value ">{{refundInfo.creationTime||''}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">退款金额：</div>
            <div class="form-value ">
              {{refundMoney}}
            </div>
          </div>
          <div class="form-cell">
            <div class="form-label">退款类型：</div>
            <div class="form-value ">{{refundType}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">退款原因：</div>
            <div class="form-value">{{refundInfo.remark}}</div>
          </div>
        </div>
      </div>
      <div class="form-block refund-gap">
        <div class="form-title">
          <div class="form-icon"></div>
          <div>
            原单信息
          </div>
          <div class="flex more-order" @click="orderDetail">
            更多详情>
          </div>
        </div>
        <div class="form-content">
          <div class="form-cell">
            <div class="form-label">应用名称：</div>
            <div class="form-value ">{{setMealInfo.appName}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">套餐名称：</div>
            <div class="form-value ">{{setMealInfo.packageName}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">实付金额：</div>
            <div class="form-value ">{{payMoney}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">购买周期：</div>
            <div class="form-value ">
              {{(setMealInfo.packagePeriodNum||0)*(setMealInfo.buyNum||0)}}{{['','天','个月'][setMealInfo.packagePeriodUnit]}}
            </div>
          </div>
          <div class="form-cell">
            <div class="form-label">订单类型：</div>
            <div class="form-value ">{{OrderTypeLabel[setMealInfo.type]}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">下单时间：</div>
            <div class="form-value ">
              {{orderInfo.creationTime}}
            </div>
          </div>
        </div>
      </div>
      <div class="form-block" v-if="showDetail">
        <div class="form-title">
          <div class="form-icon"></div>
          <div class="flex">最终审核信息</div>
        </div>
        <div class="form-content">
          <div class="form-cell">
            <div class="form-label">审核时间：</div>
            <div class="form-value ">{{ approvedLog.creationTime}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">审核结果：</div>
            <div class="form-value ">{{RefundStateLabel[approvedLog.operateState]}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">审核人：</div>
            <div class="form-value ">{{ approvedLog.realName}}</div>
          </div>
          <div class="form-cell">
            <div class="form-label">实退金额：</div>
            <div class="form-value ">{{ actualMoney}}</div>
          </div>
          <div class="form-cell full-cell">
            <div class="form-label">审核描述：</div>
            <div class="form-value ">{{ approvedLog.operateContent||''}}</div>
          </div>
          <div class="form-cell full-cell">
            <div class="form-label">附件：</div>
            <div class="form-value ">

              <preview-img :imgList="approvedLog.attachList||[]"/>
            </div>
          </div>
        </div>
      </div>
      <refund-approve :refundInfo="refundInfo" @approved="getRefundInfo" v-else-if="!showDetail&&refundInfo.id"/>
    </div>

    <ul class="refund-right">
      <li class="log-item" v-for="(log,index) in refundLogs" :key="index">
        <div class="log-text" :class="[log.logColor]">
          {{log.refundStateText}}（{{log.refundTypeText}}：{{log.realName}}）
        </div>
        <div class="log-sub" v-if="log.operateContent">{{log.operateContent}}</div>
        <preview-img v-if="log.attachList.length>0" :imgList="log.attachList"/>
        <div class="log-time">{{log.creationTime}}</div>
      </li>
    </ul>
  </div>
</template>

<script>
  import OrderService from "../../apis/orderService";
  import {
    OrderCloseStateLabel,
    OrderStateLabel,
    OrderTypeLabel,
    RefundReasonStateLabel,
    RefundState,
    RefundStateLabel,
    RefundTypeLabel
  } from "../../service/enum";
  import RefundApprove from "./refund-approve";
  import PreviewImg from "./preview-img";

  export default {
    name: "order-details",
    components: {RefundApprove, PreviewImg},
    data() {
      return {
        orderNo: "",
        orderInfo: {},
        refundInfo: {},
        OrderStateLabel,
        OrderTypeLabel,
        OrderCloseStateLabel,
        RefundStateLabel
      }
    },
    computed: {
      approvedLog() {
        return this.refundLogs[0] || {};
      },
      refundLogs() {
        if (!this.refundInfo.refundLogs || !this.refundInfo.refundLogs.length) return [];
        const refundLogs = this.refundInfo.refundLogs.map(item => {
          const attachList = this.refundInfo.attachList.filter(attach => attach.refundLogId == item.id);
          return {
            ...item,
            refundStateText: RefundStateLabel[item.operateState],
            refundTypeText: RefundTypeLabel[item.operateType],
            logColor: OrderService.getRefundLogColor(item.operateState),
            attachList
          }
        })
        return refundLogs;
      },
      refundUserInfo() {
        return this.refundInfo.refundUserInfo || {};
      },
      payMoney() {
        return this.orderInfo.payMoney !== undefined ? OrderService.toYuan(this.orderInfo.payMoney) + '元' : '';
      },
      actualMoney() {
        return this.refundInfo.actualMoney !== undefined ? OrderService.toYuan(this.refundInfo.actualMoney) + '元' : '';
      },
      refundMoney() {
        return this.refundInfo.applyMoney !== undefined ? OrderService.toYuan(this.refundInfo.applyMoney) + '元' : '';
      },
      refundType() {
        return this.refundInfo.reason ? RefundReasonStateLabel[this.refundInfo.reason] : '';
      },
      setMealInfo() {
        return this.orderInfo.details ? this.orderInfo.details[0] : {}
      },
      buyUserInfo() {
        return this.orderInfo.buyUserInfo || {};
      },
      showDetail() {
        return this.refundInfo.refundState != RefundState.approving;
      }
    },
    methods: {
      async getRefundInfo() {
        const res = await OrderService.getRefundInfo(this.orderNo);
        this.refundInfo = res;
      },
      async getOrderInfo() {
        const res = await OrderService.getOrderInfo(this.orderNo);
        this.orderInfo = res;
      },
      orderDetail() {
        this.$router.push({path: '/order-list/order-details?orderNo=' + this.orderNo})
      },
    },
    async mounted() {
      this.orderNo = this.$route.query.orderNo;
      await  this.getOrderInfo();
      await  this.getRefundInfo();
    },
    filters: {
      moneyToYuan(money) {
        if (money === 0) return "0.00";
        if (!money) return "";
        return OrderService.toYuan(money);
      }
    }
  }
</script>

<style scoped lang="scss">
  .refund-details {
    padding: 0 !important;
    .refund-left {
      margin-right: 2px;
      min-width: 900px;
      ::v-deep  .form-block {
        position: relative;
        padding-left: 20px;
        padding-top: 30px;
        &.refund-gap {
          border-bottom: 10px solid #f0f6fc;
        }

        .form-title {
          height: 32px;
          line-height: 32px;
          display: flex;
          font-size: 18px;
          color: #333;
          .form-icon {
            width: 4px;
            background-color: #1B9AEE;
            margin-right: 20px;
          }
          .more-order {
            color: #1890FF;
            font-size: 12px;
            display: flex;
            justify-content: center;
            cursor: pointer;

          }
        }
        .form-content {
          margin-top: 20px;
          display: flex;
          flex-wrap: wrap;
          &.form-approve {
            margin-top: 0;
          }

          .form-cell {
            display: flex;
            width: 300px;
            font-size: 14px;
            color: #333;
            margin-bottom: 20px;
            &.full-cell {
              width: 90%;
              &:nth-of-type(even) {
                margin-left: 0;
              }
            }

            &:nth-of-type(even) {
              min-width: 55%;
              margin-left: 60px;
            }
            .form-label {
              color: #666;
              min-width: 80px;
              &.required {
                position: relative;
                &:before {
                  content: "*";
                  position: absolute;
                  top: 0;
                  left: -8px;
                  color: red;
                }
              }
            }
          }
        }
      }
    }
    .refund-right {
      min-width: 696px;
      max-width: 696px;
      word-break: break-all;
      height: 829px;
      overflow: auto;
      border-radius: 6px;
      border: 1px solid #CDCDCD;
      margin: 44px 20px 0 0;
      padding: 20px;
      font-size: 14px;
      color: #999999;
      list-style: none;
      $blue: #1677ff;
      $red: #da1212;
      .log-item {
        padding: 0 20px 20px;
        line-height: 1;
        position: relative;
        &.item-title {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          &:before {
            background-color: #666666;
          }
        }
        &.blue {
          &:before {
            background-color: $blue;
          }
        }
        &.red {
          &:before {
            background-color: $red;
          }
        }
        &::before  {
          content: "";
          position: absolute;
          top: 4px;
          left: -2px;
          width: 8px;
          height: 8px;
          background: #e5e5e5;
          border-radius: 50%;
        }
        &::after {
          content: "";
          position: absolute;
          top: 4px;
          left: 1px;
          width: 2px;
          height: 100%;
          background: #e5e5e5;
        }
        &:last-child {
          padding-bottom: 0;
          &::after {
            display: none;
          }
        }
        /*&:first-child {*/
        /*&::after {*/
        /*display: none;*/
        /*}*/
        /*}*/
        .log-text {
          font-size: 14px;
          &.blue {
            color: $blue;
          }
          &.red {
            color: $red;
          }
        }

        .log-sub {
          font-size: 13px;
          margin-top: 8px;
          line-height: 1.5;
          color: #999999;
        }
        .log-time {
          font-size: 12px;
          margin-top: 8px;
          color: #999999;
        }
      }

    }
  }
</style>
